// React context for the global datastore.
import React from 'react';

import type { Datastore } from './datastore';

export const DatastoreContext = React.createContext<Datastore | null>(null);
